import { supportedOAuthTypes } from "./supportedOAuthTypes";
import { OktaClient } from "./okta/oktaClient";

export function createOAuthClient(OAuthConfig) {
  let authClient = null;
  const OAuthType = OAuthConfig.OAuthType;
  switch (OAuthType) {
    case supportedOAuthTypes.Okta:
      authClient = new OktaClient(OAuthConfig);
      break;
    default:
      break;
  }
  return authClient;
}
